const decodeURI = str => decodeURIComponent(JSON.parse(`"${str}"`))

export default decodeURI
